
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLearnerWeeklyGoals"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LearnerGoals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryWeeklyGoal"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetLearnerWeeklyGoals_WeeklyGoal"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetLearnerWeeklyGoals_WeeklyGoal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerGoals_WeeklyGoal"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayGoalStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetLearnerWeeklyGoals_DayGoalStatus"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"overallGoalProgressStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weeklyGoalType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerGoals_WeeklyGoalTypeDaysOfLearning"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysToLearn"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetLearnerWeeklyGoals_DayGoalStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerGoals_DayGoalStatus"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasMadeProgress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isGoalDay"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":508}};
    doc.loc.source = {"body":"query GetLearnerWeeklyGoals {\n  LearnerGoals {\n    queryWeeklyGoal {\n      ...GetLearnerWeeklyGoals_WeeklyGoal\n    }\n  }\n}\n\nfragment GetLearnerWeeklyGoals_WeeklyGoal on LearnerGoals_WeeklyGoal {\n  dayGoalStatus {\n    ...GetLearnerWeeklyGoals_DayGoalStatus\n  }\n  overallGoalProgressStatus\n  weeklyGoalType {\n    ... on LearnerGoals_WeeklyGoalTypeDaysOfLearning {\n      daysToLearn\n    }\n  }\n}\n\nfragment GetLearnerWeeklyGoals_DayGoalStatus on LearnerGoals_DayGoalStatus {\n  day\n  hasMadeProgress\n  isGoalDay\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetLearnerWeeklyGoals"] = oneQuery(doc, "GetLearnerWeeklyGoals");
        
        module.exports["GetLearnerWeeklyGoals_WeeklyGoal"] = oneQuery(doc, "GetLearnerWeeklyGoals_WeeklyGoal");
        
        module.exports["GetLearnerWeeklyGoals_DayGoalStatus"] = oneQuery(doc, "GetLearnerWeeklyGoals_DayGoalStatus");
        
